import Vue from 'vue'
import App from './App'
import router from './router'
import store from './commonality/vuex' //全局管理vuex
import './commonality/basic.css'//導入公共樣式
import 'babel-polyfill';//解析ES6語法
// 添加富文本編輯器
import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

//加載 axios http
import './commonality/http'

Vue.config.productionTip = false

import common from './commonality/common.js' //定義全局函數
Vue.use(common);

//部分引入ydui提示框
import {Loading} from 'vue-ydui/dist/lib.rem/dialog'; //提示框
Vue.prototype.$dialog = {loading: Loading};

//引入element-UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
//引入element-UI日期選擇組件
import {DatePicker,Upload} from 'element-ui'

Vue.use(DatePicker)
Vue.use(Upload)

//引入打印插件
import Print from './components/print/print' //打印插件
Vue.use(Print);
//引入PDF插件
import JsPDF from 'jspdf'//生成PDF
Vue.prototype.JsPDF = JsPDF;
//引入canvas插件
import html2Canvas from 'html2canvas'

Vue.prototype.html2Canvas = html2Canvas;
/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store,  //全局變量
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js